

export enum PixiZDepthLayers {
    Background = 0,
    Surfaces = 1,
    MapReactions = 2
}